import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import {
  SubjectAreaSummaryApiResponse,
  SubjectAreaSummaryItem,
} from '../../common/subjectTypes'
import { AsyncState } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'

const areaNames: Record<string, string> = {
  op: 'Orná půda',
  ttp: 'Trvalý travní porost',
  les: 'Les',
  vinice: 'Vinice',
  chmelnice: 'Chmelnice',
  sad: 'Sad',
  zahrada: 'Zahrada',
  zastavenaPlochaANadvori: 'Zastavěná plocha a nádvoří',
  ostatniPlocha: 'Ostatní plocha',
  vodniPlocha: 'Vodní plocha',
  celkem: 'Celkem',
}

const transformAreadData = (
  inputData: SubjectAreaSummaryApiResponse
): SubjectAreaSummaryItem[] =>
  Object.entries(inputData)
    .map(([key, value]) => ({
      id: key,
      name: areaNames[key] || key,
      areaM: value.vymera || 0,
      areaHa: (value.vymera || 0) / 10000,
      lpisArea: value.lpisPrunik || 0,
      lpisPercentage: ((value.lpisPrunik || 0) / (value.vymera || 1)) * 100,
      priceBpej: value.cenaBpej || 0,
    }))
    .filter(item => item.id !== 'celkem')

export const useFetchSubjectAreaSummary = (subjectId?: string) => {
  const { token } = useAppSelector(state => state.myProfile)

  const [state, setState] = useState<AsyncState<SubjectAreaSummaryItem[]>>({
    fetching: true,
    data: null,
    error: false,
  })

  const fetchSubjectAreaSummary = useCallback(async () => {
    if (!subjectId || !token) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
      return
    }

    setState({
      fetching: true,
      data: null,
      error: false,
    })

    try {
      const response = await axios.get<SubjectAreaSummaryApiResponse>(
        `https://data.regesta.cz/DrmApi/api/v1.0/Subjekty/${subjectId}/VlastnickaPrava/Statistika/Parcely?access_token=${token}`
      )
      const transformedData = transformAreadData(response.data)

      setState({
        fetching: false,
        data: transformedData,
        error: false,
      })
    } catch (error) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
    }
  }, [subjectId, token])

  useEffect(() => {
    fetchSubjectAreaSummary()
  }, [fetchSubjectAreaSummary])

  return state
}
